import { useContext } from 'react';
import { authConfigContext } from './auth-context';

export function useAuthConfig() {
  const authConfig = useContext(authConfigContext);
  if (!authConfig) {
    throw new Error(
      'authConfigContext value is undefined. Make sure you use the AuthProvider before using the context.'
    );
  }
  return authConfig;
}
